export default __webpack_public_path__ + "static/media/no-search-result.4ecf2791.svg";